




















































































import {Component, Vue} from "vue-property-decorator";

import {cartService, CartItem} from '../services/cart-service';
import ItemImage from '@/components/ItemImage.vue';
import MainButton from '@/components/MainButton.vue';
import {Item} from "../model";


@Component({
  components: {ItemImage, MainButton}
})
export default class ShoppingCart extends Vue {
  items: CartItem[] = [];
  total: number = 0;
  remark:string = "";

  created() {
    this.updateFromCart();
  }

  removeItem(item: Item) {
    cartService.setRemark(this.remark);
    cartService.removeFromCart(item);
    this.updateFromCart();
  }

  updateFromCart() {
    this.items = cartService.getCart().items;
    this.total = cartService.getCart().getTotalAmount();
    this.remark = cartService.getCart().remark;
  }

  quantityChanged(ci: CartItem) {
    cartService.setRemark(this.remark);
    cartService.quantityChanged(ci);
    this.updateFromCart();
  }

  checkout() {
    console.log("checkout");
    cartService.setRemark(this.remark);
    this.$router.push('/checkout');
  }
}
